import type react from 'react'
import { useState, useEffect } from 'react'
import type { AnimationItem } from 'lottie-web'
import styled from '@emotion/styled'

import Elevation from '@segment/matcha/components/Elevation'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import useIsInView from '@segment/utils/useInView'
import useLottie from '@segment/utils/useLottie/useLottie'

import jsonUrl from './assets/trust-is-good-business-lottie.json.data'

const data = {
  title: `Trust is good business.`,
  content: [
    `Digital trust must be a cornerstone of a brand’s digital transformation. Customer relationships are at stake.`,
    `55% of consumers say trustworthiness and transparency are the most important traits of a brand.`,
  ],
  animation: {
    title: `When deciding whether to shop with a particular brand, what’s most important?`,
  },
}

const TrustIsGoodBusiness: react.FC = () => {
  const [animationData, setAnimationData] = useState<Promise<Response>>()
  useEffect(() => {
    setAnimationData(fetch(jsonUrl))
  }, [])
  const [animation, containerRef] = useLottie<AnimationItem, HTMLDivElement>({
    options: {
      autoplay: false,
      animationData,
      loop: false,
    },
  })
  const isInView = useIsInView(containerRef)

  useEffect(() => {
    if (isInView) {
      animation?.play()
    }
  }, [animation, isInView])
  return (
    <SectionBase variant="2Col" reverse={true}>
      <Section.Contents>
        <CopyTextBase>
          <CopyText.Heading tag="h3" variant="h4">
            {data.animation.title}
          </CopyText.Heading>
        </CopyTextBase>
        <Elevation elevation={3} type="dropShadow">
          <Animation ref={containerRef} />
        </Elevation>
      </Section.Contents>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {data.title}
          </CopyText.Heading>
          {data.content.map((text, key) => (
            <CopyText.Description key={key} tag="p" variant="pLarge">
              {text}
            </CopyText.Description>
          ))}
        </CopyTextBase>
      </Section.Copy>
    </SectionBase>
  )
}

const Animation = styled.div`
  margin-top: 40px;
  max-width: 534px;
  aspect-ratio: 534 / 408;
`

export default TrustIsGoodBusiness
